import * as React from 'react';
import { renderText } from '../dateneingabe/assistent/assistent_helpers';
import style from './Impressum.less';

export interface ImpressumProps {
    data: any;
}

export class Impressum extends React.Component<ImpressumProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render(): JSX.Element {
        return (
            <div
                className={style.wrapper}
                style={{ padding: 20, maxWidth: 840, textAlign: 'justify', overflowY: 'auto', overflowX: 'hidden' }}
            >
                {renderText('Impressum', this.props.data)}
            </div>
        );
    }
}
